import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import IconMC from './IconMC';
import ButtonSelectorMC from './ButtonSelectorMC';

const RadioButtonSelectorMC = ({
  label,
  name,
  onSelect,
  options = [],
  className = '',
  defaultValue = '',
  labelClassName = '',
  iconPosition = 'left'
}) => {
  const { control, formState: { errors }, trigger } = useFormContext();
  const handleChange = (value, fieldChange) => {
    fieldChange(value);

    if (onSelect) {
      onSelect(value);
    }

    if (errors[name]) {
      trigger(name);
    }
  };

  const renderOptionIcon = (iconProps) => {
    if (!iconProps?.iconName) return null;

    const { iconName, size, className: iconClassName } = iconProps;

    return () => (
      <IconMC
        name={iconName}
        size={size}
        className={`tw-m${iconPosition === 'left' ? 'r' : 'l'}-3 ${iconClassName || ''}`}
      />
    );
  };

  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      render={({ field }) => (
        <div className={`tw-wrapper tw-relative ${className}`}>
          <label
            htmlFor={label}
            className={`tw-truncate tw-text-sm tw-font-semibold ${labelClassName}`}
          >
            {label}
          </label>
          <div className="tw-flex tw-flex-wrap tw-w-full">
            {options.map(({ label, value, icon }) => (
              <ButtonSelectorMC
                key={label}
                text={label}
                isSelected={value === field.value}
                onClick={() => handleChange(value, field.onChange)}
                icon={renderOptionIcon(icon)}
                className="tw-flex-grow tw-m-1"
                iconPosition={iconPosition}
              />
            ))}
          </div>
          {errors[name] && <p className="tw-text-xs tw-text-red-500">{errors[name].message}</p>}
        </div>
      )}
    />
  );
};

export default RadioButtonSelectorMC;
